import { getDeviceSchema, ROUTE_START } from "callable-data-objects";
import { CallableInput } from "Components/Shared";
import FormErrors from "Components/Shared/FormErrors";
import SimpleBreadcrumbs from "Components/Shared/SimpleBreadcrumbs";
import { Field, Formik } from "formik";
import { useDevice } from "Hooks/Endpoints";
import { isEmpty } from "lodash";
import React, { Fragment } from "react";
import {
  Button,
  Divider,
  Form,
  Header,
  Icon,
  Segment,
} from "semantic-ui-react";

const CreateInboundFlowForm = () => {
  const {
    saveFlow,
    submitting,
    nextExtension,
    validateExtension,
    validateName,
    uncreate,
  } = useDevice();

  const initValues = {
    type: ROUTE_START,
    name: "",
    extension: nextExtension,
    startRoute: {
      ddis: [],
      connectTo: "HANGUP",
    },
  };

  return (
    <Fragment>
      <SimpleBreadcrumbs
        title='Inbound Flows'
        subtitle='Create'
        onBack={uncreate}
      />
      <Segment>
        <Header as='h3'>Create Inbound Flow</Header>
        <Divider />
        <Formik
          initialValues={initValues}
          validationSchema={getDeviceSchema(ROUTE_START)}
          onSubmit={(values, actions) => {
            saveFlow(values);
          }}
        >
          {(props) => (
            <Form onSubmit={props.handleSubmit}>
              <Field
                name='name'
                label='Name'
                placeholder='Mainline'
                validate={validateName}
                component={CallableInput}
              />
              <Field
                name='extension'
                label='Extension'
                placeholder='100'
                type='number'
                validate={validateExtension}
                component={CallableInput}
              />
              <Button
                primary
                type='submit'
                disabled={submitting || !isEmpty(props.errors)}
              >
                {submitting && <Icon name='spinner' />}
                Submit
              </Button>
              <FormErrors errors={props.errors} />
            </Form>
          )}
        </Formik>
      </Segment>
    </Fragment>
  );
};

export default CreateInboundFlowForm;
